import { ro } from 'element-plus/es/locale';
import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    /* 微信小程序使用 */
    {
        path: "/map/wx/search",
        name: "WXMapSearch",
        component: ()=> import('../views/map/wx/search.vue'),
        meta: {authentication:false, keeplive: false}
    },
    {
        path: "/map/wx/drive",
        name: "WXMapDrive",
        component: ()=> import('../views/map/wx/drive.vue'),
        meta: {authentication:false, keeplive: false}
    },
    {
        path: "/test",
        name: "testFrontCode",
        component: ()=> import('../views/test.vue'),
        meta: {authentication:false, keeplive: false}
    },
    {
        path: "/games/index",
        name: "GamesIndex",
        component: ()=> import('../views/games/index.vue'),
        meta: {authentication:false, keeplive: false}
    },
    {
        path: "/map",
        name: "WebGPSMap",
        component: ()=> import('../views/web/common/map.vue'),
        meta: {authentication:false, keeplive: false}
    },
    {
        path: "/driver",
        name: "WebDriverMap",
        component: ()=> import('../views/web/common/driver.vue'),
        meta: {authentication:false, keeplive: false}
    },
//#region Web
    {
        path: '/',
        name: 'index',
        component: () => import('../views/web/index.vue'),
        meta: { 
          title: '嘉腾巴士',
          viewport: 'width=device-width, initial-scale=1.0',
          keywords: '车辆租赁,巴士租赁,商务车租赁,旅游包车,机场接送,通勤班车,嘉腾巴士',
          description: '上海嘉腾巴士租赁服务有限公司专业提供各类商务车、旅游巴士租赁服务, 线路定制, 满足您的多样出行需求。',
          robot: 'index',
        },
        children:[
            {
                path: "/",
                name: "homePage",
                component: ()=> import("../views/web/home.vue"),
                meta: {authentication:false, keeplive: false},
            },
            {
                path: "/car",
                name: "carPage",
                component: ()=> import("../views/web/car.vue"),
                meta: {authentication:false, keeplive: false},
            },
            {
                path: "/business",
                name: "businessPage",
                component: ()=> import("../views/web/business.vue"),
                meta: {authentication:false, keeplive: false},
            },
            {
                path: "/contact",
                name: "contactPage",
                component: ()=> import("../views/web/contact.vue"),
                meta: {authentication:false, keeplive: false},
            },
            {
                path: "/credential",
                name: "credentialPage",
                component: ()=> import("../views/web/credential.vue"),
                meta: {authentication:false, keeplive: false},
            },
        ]
    },
//#endregion

//#region manager 
  {
    path: "/manager",
    name: "managerIndex",
    component: ()=> import('../views/manager/index.vue'),
    meta: {authentication: true, keeplive: false, title: 'JiatengBus Administration'},
    children: [
      {
        path: "/manager",
        name: "welcomePage",
        component: ()=> import("../views/manager/welcome.vue"),
        meta: {authentication:false, keeplive: false},
      },
      {
        path: "/manager/order/payment",
        name: "ManagerRemotePayment",
        component: ()=> import("../views/manager/order/remote.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/order/stat",
        name: "managerStat",
        component: ()=> import("../views/manager/order/stat.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/order/index",
        name: "managerOrder",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            keeplive: false,
            pageTitle: '',
            componentConfig: {
                type:'orderlist'
            }
        }
      },
      {
        path: "/manager/parameters/index",
        name: "managerParameters",
        component: ()=> import("../views/manager/parameters/index.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/clientconf",
        name: "managerClientconf",
        component: ()=> import("../views/manager/parameters/clientconf.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/setting",
        name: "managerSetting",
        component: ()=> import("../views/manager/parameters/setting.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/config",
        name: "managerConfig",
        component: ()=> import("../views/manager/parameters/config.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/sms",
        name: "managerSMS",
        component: ()=> import("../views/manager/parameters/sms.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/package",
        name: "managerPackage",
        component: ()=> import("../views/manager/parameters/package.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/sysmenu",
        name: "managerSysmenu",
        component: ()=> import("../views/manager/parameters/sysmenu.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/rights",
        name: "managerRights",
        component: ()=> import("../views/manager/parameters/rights.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/role",
        name: "managerRole",
        component: ()=> import("../views/manager/parameters/role.vue"),
        meta: {authentication:true, keeplive: false},
      },
      /* file */
      {
        path: "/manager/parameters/file",
        name: "managerFile",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            keeplive: false,
            pageTitle: '文件管理',
            componentConfig: {
                type:'filelist'
            }
        }
      },
      /* finance */
      {
        path: "/manager/finance",
        name: "managerFinance1",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            keeplive: false,
            pageTitle: '财务管理',
            componentConfig: {
                type:'financelist'
            }
        }
      },
      {
        path: "/manager/finance/index",
        name: "managerFinance2",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            keeplive: false,
            pageTitle: '财务管理',
            componentConfig: {
                type:'financelist'
            }
        }
      },
      {
        path: "/manager/finance/verify",
        name: "managerVerify",
        component: ()=> import("../views/manager/finance/verify.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/finance/commission",
        name: "managerCommission",
        component: ()=> import("../views/manager/finance/commission.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/finance/hedge",
        name: "managerHedge",
        component: ()=> import("../views/manager/finance/hedge.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/parameters/doc",
        name: "managerDocument",
        component: ()=> import("../views/manager/parameters/doc.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/car",
        name: "managerCarHome",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            keeplive: false,
            pageTitle: '车辆管理',
            componentConfig: {
                type:'carlist'
            }
        }
      },
      {
        path: "/manager/car/index",
        name: "managerCar",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            keeplive: false,
            pageTitle: '车辆管理',
            componentConfig: {
                type:'carlist'
            }
        }
      },
      {
        path: "/manager/car/gps",
        name: "managerCarGPS",
        component: ()=> import("../views/manager/car/gps.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/car/cartype",
        name: "managerCarTypes",
        component: ()=> import("../views/manager/car/cartype.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/car/insurance",
        name: "managerInsurance",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            pageTitle: '保险管理',
            componentConfig: {
                isFast: false, 
                type: 'insurancelist'
            }
        }
      },
      {
        path: "/manager/car/accident",
        name: "managerAccident",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            pageTitle: '事故管理',
            componentConfig: {
                isFast: false, 
                type: 'accidentlist'
            }
        }
      },
      {
        path: "/manager/car/service",
        name: "managerService",
        component: ()=> import("../views/manager/container.vue"),
        meta: {
            authentication: true,
            pageTitle: '维修管理',
            componentConfig: {
                isFast: false, 
                type: 'servicelist'
            }
        }
      },

      {
        path: "/manager/member/enterprise",
        name: "managerEnterprise",
        component: ()=> import("../views/manager/member/enterprise.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/member/staff",
        name: "managerStaff",
        component: ()=> import("../views/manager/member/staff.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/member/driver",
        name: "managerDriver",
        component: ()=> import("../views/manager/member/driver.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: "/manager/member/index",
        name: "managerMember",
        component: ()=> import("../views/manager/member/index.vue"),
        meta: {authentication:true, keeplive: false},
      },
      {
        path: '/:pathMatch(manager/.*)', component: ()=> import('../views/manager/nofound.vue'),
      }
    ],
  },
//#endregion
    {
        path: "/manager/signin",
        name: "managerSignIn",
        component: ()=> import('../views/manager/signin.vue'),
        meta: {authentication:false, keeplive: false}
    },
]

const router = createRouter({
  history: createWebHashHistory(), //createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if(to.meta.hasOwnProperty('authentication') && to.meta.authentication == true){
    let token = localStorage.getItem('authorization');
    let type = localStorage.getItem('type');

    if (token === null || token === '') {
      if(to.fullPath.indexOf('/manager') > -1){
        next({name: "managerSignIn", params: { type: 'sfmanage' } });
      }
    } else {
      next();
    }
  }else{
    next();
  }

  if(to.meta.hasOwnProperty('title') && to.meta.title != ''){
    document.title = String(to.meta.title) ;
  }else{
    if(to.fullPath.indexOf('/manager')>-1){
        document.title = '后台管理-嘉腾巴士';
    }else{
        document.title = '嘉腾巴士';
    }
  }
});

export default router
